export default __webpack_public_path__ + "static/media/ZavalaKennethResume2022pdfWeb.b272624a.pdf";